export class StateValidationResult {
  constructor(
    public accessToken = '',
    public idToken = '',
    public authResponseIsValid = false,
    public decodedIdToken: any = {
      at_hash: '',
    }
  ) {}
}

export interface CallbackContext {
  code: string;
  refreshToken: string;
  state: string;
  authResult: AuthResult;
  validationResult: StateValidationResult;
}

export interface AuthResult {
  id_token?: string;
  access_token?: string;
  refresh_token?: string;
  error?: any;
  state?: any;
  scope?: string;
  expires_in?: number;
  token_type?: string;
}
